(function () {
  'use strict';
  if (window.__wolfReviewsRatingLoader) return;
  window.__wolfReviewsRatingLoader = true;
  var owner = document.currentScript;
  var eager = owner && owner.getAttribute('data-wolf-rating-eager') === 'true';
  var productPage = owner && owner.getAttribute('data-wolf-rating-product') === 'true';
  var scriptURL = 'https://widget.reviews.io/rating-snippet/dist.js';
  var styleURL = 'https://widget.reviews.io/rating-snippet/dist.css';
  var selector = '.ruk_rating_snippet';
  var started = false;
  var observer;

  // Wait until all app-embed tags are parsed, including embeds after this loader.
  // An enabled original embed owns its own initialization; never load it twice.
  function originalEmbedPresent() {
    return Array.prototype.some.call(document.scripts, function (script) {
      return script.src === scriptURL;
    });
  }

  function initRatingSnippet() {
    var hasStore = typeof reviewsIoStore !== 'undefined' && !!reviewsIoStore;
    if (!hasStore || typeof ratingSnippet !== 'function' || !document.querySelector(selector)) return false;
    var storeOverride = window.__REVIEWSIO_RATING_SNIPPET_STORE_OVERRIDE__;
    var storeForSnippet = storeOverride || reviewsIoStore;
    // Exact app-embed options. Its enabled anchor setting is emitted only on
    // product routes, so preserve that route-dependent behavior explicitly.
    var options = {
      store: storeForSnippet,
      color: '#000',
      textClr: '#333',
      linebreak: false,
      usePolaris: true,
      formatReviewCount: true,
      text: 'Reviews',
      lang: (typeof reviewsIoLang !== 'undefined' && reviewsIoLang) ? reviewsIoLang : 'en',
      mode: 'default',
      showEmptyStars: true,
      enableSyndication: (typeof reviewsIoEnableSyndication !== 'undefined') ? reviewsIoEnableSyndication : false
    };
    if (productPage) options.anchorToReviewsWidget = true;
    ratingSnippet('ruk_rating_snippet', options);
    var reviewsIoModal = document.getElementById('reviews_fade');
    if (reviewsIoModal) reviewsIoModal.classList.add('rio-withoutBranding');
    return true;
  }

  function load() {
    if (started) return;
    started = true;
    if (observer) observer.disconnect();
    if (originalEmbedPresent()) return;
    var scriptReady = typeof ratingSnippet === 'function';
    var styleReady = false;
    var pageReady = document.readyState === 'complete';
    var initialized = false;
    var attempts = 0;
    var retry;
    function tick() {
      if (!pageReady || !scriptReady || !styleReady || initialized || retry) return;
      attempts += 1;
      initialized = initRatingSnippet();
      if (!initialized && attempts < 20) {
        retry = window.setTimeout(function () { retry = null; tick(); }, 200);
      }
    }
    if (!pageReady) window.addEventListener('load', function () { pageReady = true; tick(); }, {once: true});
    var style = document.createElement('link');
    style.rel = 'stylesheet';
    style.href = styleURL;
    function styleSettled() { styleReady = true; tick(); }
    style.addEventListener('load', styleSettled, {once: true});
    // The original embed still initializes text if its stylesheet fails.
    style.addEventListener('error', styleSettled, {once: true});
    document.head.appendChild(style);
    if (!scriptReady) {
      var script = document.createElement('script');
      script.src = scriptURL;
      script.addEventListener('load', function () { scriptReady = true; tick(); }, {once: true});
      document.head.appendChild(script);
    }
    tick();
  }

  function start() {
    if (originalEmbedPresent()) return;
    if (eager || document.querySelector(selector)) { load(); return; }
    // Future homepage sections and asynchronously inserted app targets remain
    // supported. Inspect added subtrees and class changes on their target only.
    observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].type === 'attributes' && records[i].target.matches(selector)) {
          load(); return;
        }
        for (var j = 0; records[i].addedNodes && j < records[i].addedNodes.length; j++) {
          var node = records[i].addedNodes[j];
          if (node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))) {
            load(); return;
          }
        }
      }
    });
    observer.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['class']});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
